<template>
  <div>
    <TitleName :TitleName="TitleName"></TitleName>

    <ul class="recommend" v-if="otherdatalist.length > 0">
      <li  @click="toDatadetails(item.dataId)" v-for="(item, index) in otherdatalist.slice(0, 6)" :key="index">
        <div class="txt">
          <div class="idx">{{ index + 1 }}</div>
          <div class="name_">
            {{ item.productName }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["otherdatalist"],
  components: {
    TitleName: () => import("@/components/DataDetails/Other/TitleName.vue"),
  },
  data() {
    return {
      // TitleName: "相关推荐",
      data: [
        "南亚地区交通设施矢量数据集",
        "南亚地区交通设施矢量数据集",
        "南亚地区交通设施矢量数据集",
        "南亚地区交通设施矢量数据集",
        "南亚地区交通设施矢量数据集",
        "南亚地区交通设施矢量数据集",
        "南亚地区交通设施矢量数据集",
        "南亚地区交通设施矢量数据集",
      ],
    };
  },
   methods:{
     toDatadetails(dataId) {
      // console.log(item)
      this.$router.push(`/datadetails?dataId=${dataId}`);
    },
  },
  computed: {
    TitleName() {
      return this.$t("DataDetails.relatedRecommendations");
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend {
  border-top: 2px solid #fbfbfb;
  padding-top: 10px;
  .txt {
    font-size: 14px;
    line-height: 24px;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    white-space: nowrap;
    width: 260px;
    text-overflow: ellipsis;

    overflow: hidden;
    .idx {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      min-width: 20px;
      height: 20px;
      background: #d8b879;
      border-radius: 2px;
      color: #fff;
      margin-right: 6px;
    }
    .name_ {
      width: 240px;
      flex: 1;
        white-space: nowrap;
overflow: hidden;
    text-overflow: ellipsis;
    }
  }
}
</style>